export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Offensive Security Certified Professional (OSCP)',
            details : 'Offensive Security Certified Professional (OSCP) is an ethical hacking certification offered by Offensive Security. The OSCP is a hands-on penetration testing certification, requiring holders to successfully attack and penetrate various machines. It is considered more technical than other ethical hacking certifications.',
            date : 'Dec 7, 2021',
            field : 'Cybersecurity',
            image : 'https://images.credly.com/size/340x340/images/ec81134d-e80b-4eb5-ae07-0eb8e1a60fcd/image.png'
        },
        {
            id : 2,
            title : 'Practical Ethical Hacking - The complete Course PEH',
            details : 'Learn how to hack like a pro by a pro. 25 hours of up to date practical hacking techniques with absolutely no filler.',
            date : 'Sep 11, 2020',
            field : 'Cybersecurity',
            image : 'https://i.ibb.co/Jrf7Mbq/Capture.png'
        },
        {
            id : 3,
            title : 'PentesterLab\'s Unix Badge ',
            details : 'This exercise is one of our challenges to help you learn more about Unix/Linux.',
            date : 'May 16, 2022',
            field : 'Cybersecurity',
            image : 'https://i.ibb.co/NjDvRXF/2022-05-19-12-40-05-PTLU9932-pdf-and-1-more-page-Profile-1-Microsoft-Edge.png'
        },

        {
            id : 4,
            title : 'Introduction to Cybersecurity',
            details : 'Discover the world of cybersecurity and its impact, as you uncover the most common threats, attacks and vulnerabilities. By Cisco Networking Academy.',
            date : 'june 30, 2022',
            field : 'Cybersecurity',
            image : 'https://images.credly.com/size/340x340/images/af8c6b4e-fc31-47c4-8dcb-eb7a2065dc5b/I2CS__1_.png'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/